import { Modal } from 'antd';

import { BaseURL } from '../../../base/env';
import styles from './PopupNoticeWrapper.module.css';

const PopupNoticeWrapper = ({ showModal, PopupNoticeWrapperInfo, onCancel, onClickButton }) => (
  <Modal
    bodyStyle={{ padding: 15 }}
    centered
    closable={false}
    footer={null}
    onCancel={onCancel}
    style={{
      width: '700px'
    }}
    visible={showModal}>
    <div className={styles.PopupNoticeWrapper}>
      <div
        onClick={() => {
          onClickButton();
          window.location.replace(PopupNoticeWrapperInfo.url);
        }}>
        {PopupNoticeWrapperInfo?.image ? (
          <img
            alt="popup-info"
            className={styles.ImageElement}
            src={`${BaseURL}${PopupNoticeWrapperInfo.image}`}
            width="100%"
          />
        ) : null}
        {PopupNoticeWrapperInfo?.text ? (
          <p className={styles.Text}>{PopupNoticeWrapperInfo?.text}</p>
        ) : null}
      </div>
      <div className="text-center mar-t-20 flex center-content">
        <button
          className={`button flex-i center-content btn-h43 btn btn-red btn-300 line-none btn-round ${styles.SubmitBtn}`}
          onClick={onClickButton}
          type="button">
          متوجه شدم
        </button>
      </div>
    </div>
  </Modal>
);

export default PopupNoticeWrapper;
